import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 3a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3z","key":"svg-0"}],["path",{"d":"M18 13a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3z","key":"svg-1"}]]

const IconLayoutListFilled = createReactComponent('filled', 'layout-list-filled', 'LayoutListFilled', __iconNode);

export default IconLayoutListFilled;